import React from 'react';
import Module from './Module';

const VideoModule: React.FC = () => (
  <Module className="VideoModule" width="Unconstrained">
    <h2>See Miter in Action</h2>
    <p>
      Shared goals, real-time outcomes, facilitation in a box, automated summaries, centralized action items...get a
      one-minute crash course.
    </p>
    <iframe
      width="560"
      height="315"
      src="https://www.youtube.com/embed/7AHlyHup2A8?rel=0"
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </Module>
);

export default VideoModule;
